import { render } from "./ArchiveCohortModal.vue?vue&type=template&id=d4e4b234"
import script from "./ArchiveCohortModal.vue?vue&type=script&lang=js"
export * from "./ArchiveCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__